import React from 'react';
import { Trans } from 'react-i18next';
import { RequiredSymbol } from '../RequiredSymbol/RequiredSymbol';

/**
 * Used at the beginning of Forms, describing that all fields with * are required.
 */
export function RequiredHelpPhrase() {
  return (
    // this can be aria-hidden="true", because it is irrelevant for screen readers
    <p className="required-help-phrase font-regular-15-21" aria-hidden="true">
      <Trans i18nKey="phrases:requiredHelpText" components={[<RequiredSymbol key={1} />]} />
    </p>
  );
}
